<template>
    <div class="content-center none-click">
      <div class="banner">
        <div class="banner_box">
            <div class="banner_title">千橙营销</div>
            <div class="banner_line"></div>
            <!-- <div class="banner_title2">打造以业务员为核心的超级业务员管理系统</div> -->
            <div class="banner_text">智能化精准化的会员管理和营销</div>
        </div>
        <img src="@/assets/Mobile/images/QcMarketing/banner.png" alt="">
      </div>
      <div class="programme programme1" style="padding: 0 0 33px 30px;">
        <div class="sk-mobile-title">
          <div class="title">会员营销的七大业务痛点</div>
        </div>
        <div class="content">
            <img src="@/assets/Mobile/images/QcMarketing/programme1.png" alt="">
        </div>
      </div>
      <div class="programme">
        <div class="sk-mobile-title">
          <div class="title">搭配拉新工具，多渠道引流，解决“获客难”</div>
        </div>
        <div class="content" style="margin-top: 25px;">
            <img src="@/assets/Mobile/images/QcMarketing/programme2.png" alt="">
        </div>
      </div>
      <div class="programme programme1">
        <div class="sk-mobile-title">
          <div class="title">多渠道客户收集与统一管理，解决“管理难”</div>
        </div>
        <div class="content">
            <img src="@/assets/Mobile/images/QcMarketing/programme3.png" alt="">
        </div>
      </div>
      <div class="programme">
        <div class="sk-mobile-title">
          <div class="title">完善客户资料，深度客户洞察，解决“识别难”</div>
        </div>
        <div class="content" style="margin-top: 25px;">
            <img src="@/assets/Mobile/images/QcMarketing/programme4.png" alt="">
        </div>
      </div>
      <div class="programme programme1">
        <div class="sk-mobile-title">
          <div class="title">标准化场景及精准化智能化匹配，解决“转化难”问题</div>
        </div>
        <div class="content">
            <img src="@/assets/Mobile/images/QcMarketing/programme5.png" alt="">
        </div>
      </div>
      <div class="programme">
        <div class="sk-mobile-title">
          <div class="title">促销与触达形式多样，解决“活跃难”</div>
        </div>
        <div class="content" style="margin-top: 25px;">
            <img src="@/assets/Mobile/images/QcMarketing/programme6.png" alt="">
        </div>
      </div>
      <div class="programme programme1">
        <div class="sk-mobile-title">
          <div class="title">会员忠诚和成长体系打造，解决“留存难”</div>
        </div>
        <div class="content">
            <img src="@/assets/Mobile/images/QcMarketing/programme7.png" alt="">
        </div>
      </div>
      <div class="programme">
        <div class="sk-mobile-title">
          <div class="title">效果分析及决策指导，解决“分析难”</div>
        </div>
        <div class="content" style="margin-top: 25px;">
            <img src="@/assets/Mobile/images/QcMarketing/programme8.png" alt="">
        </div>
      </div>
      <div class="programme programme2">
        <div class="sk-mobile-title">
          <div class="title">多场景多维度营销解决方案</div>
        </div>
        <div class="content">
            <img src="@/assets/Mobile/images/QcMarketing/programme9.png" alt="">
        </div>
      </div>
      <Case title="微商城" />
      <ContactForm info-sources="千橙营销" />
      <TryModal v-if="tryVisible" :visible="tryVisible" info-sources="千橙营销" @cancel="modalClose" />
  
    </div>
  </template>
  
  <script>
  import metaInfo from '@/common/util/metaInfo'
  import ContactForm from '@/Mobile/Mobilecom/ContactForm'
  import Case from '@/Mobile/Mobilecom/Case'
  import TryModal from '@/Mobile/Mobilecom/TryModal'
  
  export default {
    metaInfo: metaInfo.QcMarketing,
    components: {
      ContactForm,
      Case,
      TryModal
    },
    data() {
      return {
        tryVisible: false,
        tooItem:'1',
      }
    },
    mounted() {
  
    },
    methods: {
      linkTo(path) {
          this.$router.push({ path: '/m/' + path })
          this.$nextTick(() => {
              this.open = false
          })
      },
      checkBg(item) {
        this.tooItem = item;
      },
      openModal: function() {
        this.tryVisible = true
      },
      modalClose: function(data) {
        this.tryVisible = data
      }
    }
  }
  </script>
  
  <style lang="less" scoped>
  .content_btn{
    width: 100%;
    height: 35px;
    position: absolute;
    bottom: 0;
    left: 0;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    .btn_box{
        height: 33px;
        width: 110px;
    }
  }
  .programme1{
    background: #FFFFFF;
  }
  .programme2{
    background: #F4F5FB;
  }
  .programme3{
    background: #202239;
  }
  .banner_box{
    position: absolute;
    top: 25px;
    left:16px;
    .banner_title{
        height: 25px;
        font-size: 18px;
        font-family: FZLTZHK--GBK1, FZLTZHK--GBK1;
        font-weight: normal;
        color: #FFFFFF;
        line-height: 25px;
        text-align: left;
    }
    .banner_title2{
        width: 142px;
        height: 28px;
        font-size: 10px;
        font-family: FZLTZHK--GBK1, FZLTZHK--GBK1;
        font-weight: normal;
        color: #FFFFFF;
        line-height: 14px;
        margin-top: 9px;
        text-align: left
    }
    .banner_line{
        width: 50px;
        height: 3px;
        background: #28DAFB;
        margin-top:6px;
        
    }
    .banner_text{
        margin-top:22px;
        width: 134px;
        height: 78px;
        font-size: 10px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        color: #FFFFFF;
        line-height: 17px;
        text-align: left
    }
  }
  .banner {
    width: 100%;
    height: 200px;
    margin-top: 50px;
    position: relative;
    img {
      display: block;
      width: 100%;
      height: 100%;
    }
  }
 
  </style>
  